import { ArrowDown, ArrowUp } from 'lucide-react'

import { useReportStore } from '@/modules/report/useReportsStore'
import { Separator } from '@/modules/shared/components/ui/separator'
import { priceFormatter } from '@/modules/shared/utils/formatter'

export function CardReportSales() {
  const jsonSalesGoal = useReportStore((state) => state.jsonSalesGoal)

  return (
    <div className="w-1/2 bg-green-500 rounded-md border border-gray-100 shadow-md p-2 text-white text-sm">
      <div className="flex justify-between mb-2">
        <p>Vendas</p>
        {jsonSalesGoal?.resumo.valorFalta < 0 ? (
          <ArrowUp color="white" size={20} />
        ) : (
          <ArrowDown color="white" size={20} />
        )}
      </div>

      <Separator />

      <div className="text-center pt-3">
        <p>
          <strong>{priceFormatter.format(jsonSalesGoal?.resumo?.valor)}</strong>
        </p>
      </div>

      <div className="w-3/5 pt-3">
        <p>Qtd Vendas</p>
        <p>{jsonSalesGoal?.resumo?.quantidadeVendas}</p>
      </div>
    </div>
  )
}
